import styled, { CSSObject } from '@emotion/styled'
import { StyledHTMLElement } from 'shop/theme/types'

export const Container = styled.div<StyledHTMLElement>(
  ({ theme }): CSSObject => ({
    display: 'flex',
    flexDirection: 'column',
    padding: '32px',
    gap: '24px',
    justifyContent: 'center',
    '& >button': {
      borderRadius: theme.borderRadius
    },
    '> p': { margin: 0 }
  })
)

export const Header = styled.h1<StyledHTMLElement>(
  (): CSSObject => ({
    fontSize: '24px',
    alignSelf: 'left'
  })
)

export const Text = styled.p<StyledHTMLElement>(
  (): CSSObject => ({
    fontSize: '16px',
    lineHeight: '24px',
    color: '#595959'
  })
)
